import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createAppSettings, deleteAppSetting, getAppSettingList, updateAppSettings, updateAppSettingsStatus } from '../../Redux/appSettingSlice'
import { 
  IoAddOutline, 
  IoSettingsOutline,
  IoKeyOutline,
  IoPencilOutline,
  IoTrashOutline,
  IoRefreshOutline,
  IoCloseOutline,
  IoCheckmarkOutline,
  IoAlertCircleOutline
} from 'react-icons/io5';
import { 
  FiSettings, 
  FiPlus, 
  FiRefreshCw,
  FiGrid,
  FiCheckCircle,
  FiXCircle,
  FiSearch,
  FiFilter
} from "react-icons/fi";
import { MdOutlineSettings } from "react-icons/md";
import AppSettingTable from './Table/AppSettingTable';
import CreateAppSettingModal from './Modal/CreateAppSettingModal';
import Loader from '../../components/Loader/Loader';


const feildsData = {
  name: "", key: "", value: ''
}

const AppSetting = () => {
  const selector = useSelector(state => state)
  const dispatch = useDispatch()
  const { appSettingSlice: { getAllAppSettings: { total = [], list = null }, loading } } = selector ? selector : { appSettingSlice: { getAllAppSettings: { total: [], list: [] }, loading: false } }
  const [clickedUserId, setClickedUserId] = useState(null)
  const [isMenu, setIsMenu] = useState(false)
  const [error, setError] = useState({})
  const [searchTerm, setSearchTerm] = useState('')
  const [sortKey, setSortKey] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  const handleSort = (key) => {
    if (sortKey === key) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortOrder("asc");
    }
  };

  const tableHead = [
    { label: '#', sortKey: null },
    { label: 'Id', sortKey: null },
    { label: 'Name', sortKey: 'name' },
    { label: 'Status', sortKey: 'isDisable' },
    { label: '', sortKey: null },
    { label: 'Action', sortKey: null }
  ]
  /// Row Data====>>>>
  const [clickedRowData, setClickedRowData] = useState(null)

  /// Create State ===>>>>
  const [isCreateAppSettingModal, setIsCreateAppSettingModal] = useState(false)
  const [inputValue, setIsInputValue] = useState(feildsData)

  /// Edit State=====>
  const [isEditModal, setIsEditModal] = useState(false)


  const apiFetchCred = {
    "pageNo": '1',
    "size": 50,
    "keyWord": "",
    "sortKey": sortKey,
    "sortOrder": sortOrder
  }
  useEffect(() => {
    dispatch(getAppSettingList(apiFetchCred))
  }, [dispatch, sortKey, sortOrder])

  // Filter out FAQ-related settings
  const filteredData = Array.isArray(list) ? list.filter(e => 
    !(e?.name?.startsWith('General Questions') ||
      e?.name?.startsWith('For Learners') ||
      e?.name?.startsWith('Technical and Security Questions') ||
      e?.name?.startsWith('Community and Support') ||
      e?.name?.startsWith('For Educator'))
  ) : [];

  // Apply search filter
  const searchedData = filteredData.filter(item => {
    const searchLower = searchTerm.toLowerCase();
    return item?.name?.toLowerCase().includes(searchLower) ||
           item?.key?.toLowerCase().includes(searchLower) ||
           item?.value?.toLowerCase().includes(searchLower);
  });

  const showMenu = (chatUserId) => {
    if (clickedUserId === chatUserId) {
      setIsMenu(!isMenu);
    } else {
      setClickedUserId(chatUserId);
      setIsMenu(true);
    }
  };

  const handleCreateValidate = () => {
    let newError = {}
    if (!inputValue?.name?.trim()) newError.name = 'Name is required';
    if (!inputValue?.key?.trim()) newError.key = 'Key is required';
    if (!inputValue?.value?.trim()) newError.value = 'Value is required';
    setError(newError);
    return Object.keys(newError).length === 0
  }
  const handleEditValidate = () => {
    let newError = {}
    if (!clickedRowData?.name?.trim()) newError.name = 'Name is required';
    if (!clickedRowData?.key?.trim()) newError.key = 'Key is required';
    if (!clickedRowData?.value?.trim()) newError.value = 'Value is required';
    setError(newError);
    return Object.keys(newError).length === 0
  }

  const handleCreateAppSettings = () => { setIsCreateAppSettingModal(!isCreateAppSettingModal) }
  const toggleCreateModal = () => { setIsCreateAppSettingModal(!isCreateAppSettingModal); setIsInputValue(feildsData); setError(null) }
  const handleCreateOnChange = (e) => { const { name, value } = e.target; setIsInputValue({ ...inputValue, [name]: value }); setError(null) }

  const handleCreateSubmit = (e) => {
    e.preventDefault()
    if (!handleCreateValidate()) return;
    let payload = {
      name: inputValue?.name,
      key: inputValue?.key,
      value: inputValue?.value
    }
    dispatch(createAppSettings({ Payload: payload, forReferesh: apiFetchCred }))
    setIsCreateAppSettingModal(false)
    setIsInputValue(feildsData)
    setError(null)
  }

  const handleAction = async (action, data) => {
    setClickedRowData(data)
    let payload = {
      "id": data?._id
    }
    switch (action) {
      case 'EDIT':
        setIsEditModal(prevState => !prevState)
        break;
      case 'STATUS':
        dispatch(updateAppSettingsStatus({ Payload: payload, forReferesh: apiFetchCred }))
        break;
      case 'DELETE':
        dispatch(deleteAppSetting({ Payload: payload, forReferesh: apiFetchCred }))
      default:
        break;
    }
  }

  const toggleupdateModal = () => { setIsEditModal(prevState => !prevState); setError(null) }
  const handleEditOnChange = (e) => { const { name, value } = e.target; setClickedRowData({ ...clickedRowData, [name]: value }); setError(null) }
  const handleUpdateAppSettings = (e) => {
    e.preventDefault();
    if (!handleEditValidate()) return;
    let payload = {
      id: clickedRowData?._id,
      name: clickedRowData?.name,
      key: clickedRowData?.key,
      value: clickedRowData?.value
    }
    dispatch(updateAppSettings({ Payload: payload, forReferesh: apiFetchCred }))
    setIsEditModal(prevState => !prevState)
    setClickedRowData(null)
  }

  // Calculate statistics
  const totalSettings = searchedData.length;
  const activeSettings = searchedData.filter(item => !item?.isDisable).length;
  const inactiveSettings = searchedData.filter(item => item?.isDisable).length;

  return (
    <div className="min-h-screen bg-gray-50/80" onClick={() => setIsMenu(!isMenu)}>
      <Loader loading={loading} />

      {/* Header Banner */}
      <div className="bg-gradient-to-r from-[#855DF6] via-[#7B5CF6] to-[#715EFE] shadow-lg relative overflow-hidden">
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-20 -mt-20 animate-pulse"></div>
        <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-12 -mb-12 animate-pulse"></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 animate-pulse"></div>
        
        <div className="relative z-10 px-4 md:px-7 py-6 md:py-8">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
            <div className="flex items-center gap-3">
              <div className="p-2.5 bg-white/20 rounded-xl backdrop-blur-sm shadow-lg">
                <MdOutlineSettings className="w-5 h-5 text-white md:w-6 md:h-6" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-white md:text-2xl dahboardFont tracking-tight">
                  App Setting Management
                </h2>
                <p className="text-sm text-white/70 hidden sm:block">
                  Manage application settings and configurations
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {/* <button
                onClick={handleCreateAppSettings}
                className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-[#715EFE] bg-white rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-lg hover:shadow-xl"
              >
                <FiPlus className="w-4 h-4" />
                <span className="hidden sm:inline">Create Setting</span>
                <span className="sm:hidden">Add</span>
              </button> */}
              {/* <div className="flex items-center gap-2 px-3 py-1.5 bg-white/20 rounded-full backdrop-blur-sm">
                <FiRefreshCw className="w-3.5 h-3.5 text-white/70" />
                <span className="text-xs text-white/80">
                  {new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                </span>
              </div> */}
            </div>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-3 gap-3 mt-5 md:gap-4">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-bold text-white uppercase md:text-lg">Total</p>
                  <p className="text-xl font-bold text-white md:text-2xl mt-0.5">{totalSettings}</p>
                </div>
                <div className="p-2 rounded-xl bg-blue-500/30 shadow-inner">
                  <FiSettings className="w-4 h-4 text-white md:w-5 md:h-5" />
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-bold text-white uppercase md:text-lg">Active</p>
                  <p className="text-xl font-bold text-emerald-300 md:text-2xl mt-0.5">{activeSettings}</p>
                </div>
                <div className="p-2 rounded-xl bg-emerald-500/30 shadow-inner">
                  <FiCheckCircle className="w-4 h-4 text-emerald-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-3 md:p-4 border border-white/20 hover:bg-white/20 transition-all duration-300">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-lg font-bold text-white uppercase md:text-lg">Inactive</p>
                  <p className="text-xl font-bold text-rose-300 md:text-2xl mt-0.5">{inactiveSettings}</p>
                </div>
                <div className="p-2 rounded-xl bg-rose-500/30 shadow-inner">
                  <FiXCircle className="w-4 h-4 text-rose-300 md:w-5 md:h-5" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <section className="px-3 py-4 -mt-4 md:px-6 lg:px-10 md:py-6">
        <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow duration-300 border border-gray-100/80 overflow-hidden">
          {/* Search Bar */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 md:p-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/50 to-white">
            <div className="flex items-center gap-3">
              <div className="p-1.5 bg-gradient-to-br from-[#855DF6]/10 to-[#715EFE]/10 rounded-lg">
                <FiGrid className="w-4 h-4 text-[#715EFE]" />
              </div>
              <div>
                <h3 className="text-sm font-semibold text-gray-700">
                  Settings List
                </h3>
                <p className="text-xs text-gray-400 hidden sm:block">
                  {totalSettings} settings • {activeSettings} active
                </p>
              </div>
            </div>
            <div className="relative flex-1 sm:min-w-[250px]">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search settings by name or key..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 pr-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#715EFE]/20 focus:border-[#715EFE] transition-all duration-200"
              />
            </div>
          </div>

          {/* Table */}
          <div className="p-0">
            <AppSettingTable 
              tableName={`App Settings`} 
              thead={tableHead} 
              data={searchedData} 
              total={total} 
              showMenu={showMenu} 
              clickedUserId={clickedUserId} 
              isMenu={isMenu}
              onActionClick={handleAction} 
              currentSortKey={sortKey}
              currentSortOrder={sortOrder}
              onSort={handleSort}
            />
          </div>
        </div>
      </section>

      {/*========>>>>>> Create Modal <<<<<<===================*/}
      {/* {isCreateAppSettingModal && (
        <CreateAppSettingModal 
          title={'Create App Setting'} 
          onCancel={toggleCreateModal} 
          inputData={inputValue} 
          handleONChange={handleCreateOnChange} 
          onSubmit={handleCreateSubmit} 
          error={error} 
        />
      )} */}

      {/*========>>>>>> Update Modal <<<<<<===================*/}
      {isEditModal && (
        <CreateAppSettingModal 
          title={`Update App Settings`} 
          inputData={clickedRowData} 
          onCancel={toggleupdateModal} 
          onSubmit={handleUpdateAppSettings} 
          handleONChange={handleEditOnChange} 
          error={error} 
        />
      )}
    </div>
  )
}

export default AppSetting